import axios from 'axios';
import { auth_token } from './components/redux/constants';

const API_URL = 'http://localhost:8080';

const apiService = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        "Authorization": sessionStorage.getItem(auth_token)
    }
});


export default apiService;